// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3zQw3","label":"Section_label__1Ihus","contentWrap":"Section_contentWrap__2RZsv","footer":"Section_footer__2QsrN","footerInner":"Section_footerInner__1PW98"};